import LabeledTextInput from '../../generic/Forms/LabeledTextInput';

export type EnterIdentifierStepProps = {
  identifier: string;
  onIdentifierChange: (value: string) => void;
};

/**
 * The credential-entry step: a labelled field accepting an email or a username (`type="text"` so the browser does not
 * reject usernames). The page owns submission via the surrounding `AuthCard` form, so this is a pure controlled input.
 */
const EnterIdentifierStep = ({ identifier, onIdentifierChange }: EnterIdentifierStepProps) => (
  <LabeledTextInput
    label="Email or username"
    type="text"
    name="identifier"
    placeholder="Enter your username or email"
    value={identifier}
    autoFocus
    isRequired
    onChange={onIdentifierChange}
  />
);

export default EnterIdentifierStep;
